<template>
  <div class="mt-0 pt-0">
    <v-card class="elevation-2" outlined>
      <v-card-title class="d-flex flex-wrap align-center" style="gap: 12px;">
        <div>
          <div class="text-h6">Prospectos</div>
          <div class="text-body-2 text--secondary">
            Mueve prospectos a pre‑registro y acelera el cierre
          </div>
        </div>
        <v-spacer></v-spacer>
        <v-chip color="deep-orange lighten-4" class="deep-orange--text text--darken-4" small>
          Total: {{ contactos.length }}
        </v-chip>
      </v-card-title>

      <v-card-text class="pt-2">
        <v-row dense class="mb-2">
          <v-col cols="12" md="5">
            <v-text-field
              v-model="search"
              dense
              outlined
              clearable
              prepend-inner-icon="mdi-magnify"
              label="Buscar prospecto"
              hide-details
            />
          </v-col>
          <v-col cols="12" md="7" class="d-flex justify-end align-center" style="gap: 8px;">
            <v-btn color="deep-orange" text @click="listar">
              <v-icon left>mdi-refresh</v-icon>
              Actualizar
            </v-btn>
          </v-col>
        </v-row>

        <v-data-table
          :headers="xheaders"
          :items="filteredContactos"
          :loading="loading"
          :items-per-page="55"
          dense
          class="elevation-1"
          no-data-text="No hay prospectos para mostrar"
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table" />
          </template>
          <template v-slot:[`item.opt`]="{ item }">
            <!-- <v-btn small color="green" outlined @click="pre_registrar_prospecto(item)">
              <v-icon left small>mdi-file-document-edit</v-icon>
              ??
            </v-btn> -->

            <!-- <v-btn small color="green" outlined @click="proceder_preinscripcion(item)">
              <v-icon left small>mdi-file-document-edit</v-icon>
              Pre-inscribir
            </v-btn> -->
            <v-btn small color="green" outlined @click="proceder_inscripcion(item)">
              <v-icon left small>mdi-file-document-edit</v-icon>
              Preinscribir
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <pre_registrar ref="refpre_registrar" />
    <ModalPreins ref="refModalPreins" @done="listar" />
  </div>
</template>

<script>
import pre_registrar from './pre_registrar.vue';
import ModalPreins from './inscripcion/modal_preins.vue';
  import { headers2, getProspectos } from './utils';

  export default {
    components: {
      pre_registrar,
      ModalPreins,
    },
    data() {
      return {
        loading: false,
        xheaders: headers2(),
        contactos: [],
        search: '',
      };
    },
    computed: {
      filteredContactos() {
        if(!this.search) return this.contactos;
        const q = this.search.toLowerCase();
        return this.contactos.filter(c =>
          Object.values(c).some(v => String(v).toLowerCase().includes(q))
        );
      }
    },
    methods: {
      async listar() {
        this.loading = true;
        const q = {
            asesor_id: this.$store.state.DATA_USER.id,
            estado: 'PROSPECTO'
        }
        const res = await getProspectos(q);
        this.loading = false;
        this.contactos = res;
      },
      pre_registrar_prospecto(row) {
        this.$refs.refpre_registrar.openmodal(row);
      }, 
      proceder_preinscripcion(row) {
        const rowWithAsesor = { ...row, asesor_id: this.$store.state.DATA_USER.id };
        this.$refs.refModalPreins.openmodal(rowWithAsesor);
      },
      proceder_inscripcion(row) {  
        const asesor_id = this.$store.state.DATA_USER.id
        this.$router.push(`/prospectos_ins/${row.programa_id}?asesor_id=${asesor_id}&persona_id=${row.persona_id}&prospecto_id=${row.id}&persona_name=${row.persona_name}`);
      },
    },
    mounted() {
      this.listar();
    },
  };
</script>
